import type { ExternalSiteRule } from "../../types";
import { SITE_TYPE } from "./const";

const wix: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("window.bi.wixBiSession.isServerSide")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [],
};

export default wix;
